export const drawerCopy = { item: "Avisos" } as const;
